//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      tableData:[],
      pageNo:1,
      total:10,
      dateText:'',
      settingList:[],
    }
  },
  mounted(){
    this.setting()
    this.info()
  },
  methods:{
    setting(){
      this.$axios.get('/mtea/stock/enum_setting').then(res=>{
        this.settingList = JSON.parse(res).goods_unit
      })
    },
    info(val = 1){
      let date = new Date()
      this.dateText = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + (date.getSeconds()<10?"0"+date.getSeconds():date.getSeconds())
      this.pageNo = val
      let data = {
        dealerId:window.sessionStorage.getItem('dealerId'),
        pageNo:this.pageNo,
        pageSize:10,
        sysShopId:this.$route.query.shopId
      }  
      this.$axios.post('/mtea/stock/dealer/shopping/stockHistory',data).then(res => {
        console.log(res)
        res.page.rows.forEach(e => {
          e.goodsUnit = this.cell(e.goodsUnit)
        });
        this.tableData = res.page.rows
        this.total = res.page.total
      })
    },
    cell(sub) {
      for (let i = 0; i < this.settingList.length; i++){
        if (this.settingList[i].value == sub) {
          return this.settingList[i].name
        }
      }
    },
    headerStyle(){
      let style = {}
      style.color = '#000'
      style['font-weight'] = 600
      style['text-align'] = 'center'
      style['background-color'] = '#f1f1f1'
      return style
    },
    rowStyle(){
      let style = {}
      style['text-align'] = 'center'
      style['font-size'] = '12px'
      return style
    },
  }
}
